angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerListController', ['$scope', 'virtoCommerce.marketplaceModule.webApi', 'platformWebApp.dialogService', 'platformWebApp.bladeUtils', 'platformWebApp.uiGridHelper', 'platformWebApp.ui-grid.extension', 'platformWebApp.metaFormsService',
        function ($scope, marketplaceApi, dialogService, bladeUtils, uiGridHelper, gridOptionExtension, metaFormsService) {
            $scope.uiGridConstants = uiGridHelper.uiGridConstants;

            var blade = $scope.blade;
            blade.headIcon = 'fas fa-store';

            var bladeNavigationService = bladeUtils.bladeNavigationService;

            blade.refresh = function (parentRefresh) {
                blade.isLoading = true;

                var searchCriteria = getSearchCriteria();

                if (blade.searchCriteria) {
                    angular.extend(searchCriteria, blade.searchCriteria);
                }

                marketplaceApi.searchSellers(searchCriteria, function (data) {
                    blade.isLoading = false;

                    $scope.pageSettings.totalItems = data.totalCount;

                    $scope.listEntries = data.results ? data.results : [];
                });

                if (parentRefresh && blade.parentRefresh) {
                    blade.parentRefresh();
                }
            };

            if (!blade.customizeToolbar) {
                blade.toolbarCommands = [
                    {
                        name: "platform.commands.refresh", icon: 'fa fa-refresh',
                        executeMethod: blade.refresh,
                        canExecuteMethod: function () {
                            return true;
                        }
                    },
                    {
                        name: "platform.commands.add", icon: 'fas fa-plus',
                        executeMethod: function () {
                            var newBlade = {
                                id: 'sellerAdd',
                                title: 'marketplace.blades.seller-add.title',
                                subtitle: 'marketplace.blades.seller-add.subtitle',
                                controller: 'virtoCommerce.marketplaceModule.sellerAddController',
                                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/seller-add.tpl.html'
                            };
                            bladeNavigationService.showBlade(newBlade, blade);
                        },
                        canExecuteMethod: function () {
                            return true;
                        }
                    },
                    {
                        name: "platform.commands.delete", icon: 'fas fa-trash-alt',
                        executeMethod: function () { deleteList($scope.gridApi.selection.getSelectedRows()); },
                        canExecuteMethod: function () {
                            return $scope.gridApi && _.any($scope.gridApi.selection.getSelectedRows());
                        }
                    }
                ];
            }

            var setSelectedNode = function (listItem) {
                $scope.selectedNodeId = listItem.id;
            };

            $scope.selectNode = function (listItem) {
                setSelectedNode(listItem);

                $scope.showDetails(listItem);
            }

            $scope.showDetails = function (listItem) {
                var foundMetaFields = metaFormsService.getMetaFields('Seller');
                var newBlade = {
                    id: 'sellerDetails',
                    title: listItem.name,
                    subtitle: 'marketplace.blades.seller-details.subtitle',
                    currentEntity: listItem,
                    controller: 'virtoCommerce.marketplaceModule.sellerDetailsController',
                    template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/seller-details.tpl.html',
                    metaFields: foundMetaFields
                };
                bladeNavigationService.showBlade(newBlade, blade);
            };

            $scope.delete = function (data) {
                deleteList([data]);
            };

            function deleteList(selection) {
                var dialog = {
                    id: "confirmDeleteVendor",
                    title: "marketplace.dialogs.sellers-delete.title",
                    message: "marketplace.dialogs.sellers-delete.message",
                    callback: function (remove) {
                        if (remove) {
                            bladeNavigationService.closeChildrenBlades(blade, function () {
                                blade.isLoading = true;

                                var memberIds = _.pluck(selection, 'id');
                                if (_.any(memberIds)) {
                                    marketplaceApi.deleteSellers({ ids: memberIds }, function() {
                                        $scope.gridApi.selection.clearSelectedRows();
                                        blade.refresh(true);
                                    });
                                }
                            });
                        }
                    }
                };
                dialogService.showConfirmationDialog(dialog);
            }

            var filter = $scope.filter = { keyword: null };

            filter.criteriaChanged = function () {
                if ($scope.pageSettings.currentPage > 1) {
                    $scope.pageSettings.currentPage = 1;
                } else {
                    blade.refresh();
                }
            };

            $scope.setGridOptions = function (gridId, gridOptions) {
                $scope.gridOptions = gridOptions;
                gridOptionExtension.tryExtendGridOptions(gridId, gridOptions);

                gridOptions.onRegisterApi = function (gridApi) {
                    $scope.gridApi = gridApi;
                    gridApi.core.on.sortChanged($scope, function () {
                        if (!blade.isLoading) blade.refresh();
                    });
                    gridApi.selection.on.rowSelectionChanged($scope, function () {
                        blade.selectedVendors = $scope.gridApi.selection.getSelectedRows();
                    });
                    gridApi.core.on.rowsRendered($scope, function () {
                        $scope.updateSelections();
                    })
                };

                bladeUtils.initializePagination($scope);
            };

            $scope.updateSelections = function () {
                if ($scope.gridApi && blade.selectedVendorIds) {
                    _.each(blade.selectedVendorIds, x => {
                        _.each($scope.gridApi.grid.rows, y => {
                            if (y.entity.id === x) {
                                y.isSelected = true;
                            }
                        })
                    });
                }
            };

            function getSearchCriteria() {
                var searchCriteria = {
                    keyword: filter.keyword ? filter.keyword : undefined,
                    sort: uiGridHelper.getSortExpression($scope),
                    skip: ($scope.pageSettings.currentPage - 1) * $scope.pageSettings.itemsPerPageCount,
                    take: $scope.pageSettings.itemsPerPageCount
                };
                return searchCriteria;
            }
        }
]);
